import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class UserInput extends Component {
  static propTypes = {
    advanceField: PropTypes.func,
    autofocus: PropTypes.bool,
    clockType: PropTypes.oneOf(['employees', 'mechanics']),
    onChange: PropTypes.func.isRequired, // returns valid id or null
    users: PropTypes.object.isRequired, // keyed on id
    defaultValue: PropTypes.string,
  };

  state = {
    focused: false,
    inputValue: '', // last value entered by user
    userActive: null, // user id ONLY IF valid ID found
  };

  focus() {
    this.input.focus();
    return this;
  }

  checkInputValue = inputValue => {
    let userActive = null;
    if (inputValue in this.props.users) {
      userActive = inputValue;
    }

    this.props.onChange(userActive);

    this.setState({
      focused: false,
      inputValue,
      userActive,
    });
  };

  handleBlur = e => {
    this.checkInputValue(e.target.value.trim().toUpperCase());
  };

  handleFocus = () => {
    this.setState({
      focused: true,
    });
  };

  reset = () => {
    this.setState({
      focused: false,
      inputValue: '',
      userActive: null,
    });

    return this;
  };

  componentDidMount() {
    if (this.props.defaultValue) {
      this.checkInputValue(this.props.defaultValue.toUpperCase());
      return;
    }

    if (this.props.autofocus) {
      this.input.focus();
    }
  }

  render() {
    const style = {};

    if (!!this.state.inputValue && !this.state.focused) {
      // input exists and we're blurred?
      if (this.state.userActive) {
        style.color = 'green';
        style.backgroundColor = '#efe';
        this.input.value = `${this.state.userActive}: ${this.props.users[this.state.userActive]}`;
      } else {
        style.color = 'red';
        style.backgroundColor = '#fee';
        this.input.value = `${this.state.inputValue} - NOT FOUND`;
      }
    } else if (this.input) {
      // empty input or focused
      this.input.value = this.state.inputValue;
    }

    let placeholder = '';
    switch (this.props.clockType) {
      case 'employees':
        placeholder = 'Employee ID';
        break;
      case 'mechanics':
        placeholder = 'Technician ID';
        break;
      default:
        placeholder = 'Unsupported clocktype.';
    }

    return (
      <div>
        <input
          className="tc-user-control"
          placeholder={placeholder}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          onKeyPress={evt => {
            if (evt.key === 'Enter' && evt.target.value !== '') {
              this.input.blur();
              this.props.advanceField();
            }
          }}
          ref={input => {
            this.input = input;
          }}
          style={style}
        />
      </div>
    );
  }
}
